import { EuiConfirmModal } from "@inscopix/ideas-eui";

interface ModalConfirmStartTasksProps {
  onCancel: () => void;
  onConfirm: () => void;
  numberOfTasks: number;
}

export const ModalConfirmStartTasks = ({
  onCancel,
  onConfirm,
  numberOfTasks,
}: ModalConfirmStartTasksProps) => {
  return (
    <EuiConfirmModal
      cancelButtonText="Cancel"
      confirmButtonText="Start"
      defaultFocusedButton="confirm"
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={`Do you want to start ${numberOfTasks} task(s) now?`}
    />
  );
};
